import moment from "moment";

//Refund
export const getValueProperty = (item) => {
    if (item.creditRefunded !== undefined) return 'creditRefunded';
    if (item.totalUsersRefunded !== undefined) return 'totalUsersRefunded';
    if (item.tokenRefunded !== undefined) return 'tokenRefunded';
    if (item.creditConsumed !== undefined) return 'creditConsumed';
    if (item.tokenPurchased !== undefined) return 'tokenPurchased';
    return null;
};
export function extractTokenRefunded(totalCreditRefunded) {
    return totalCreditRefunded?.map(item => ({
        _id: item?._id,
        tokenRefunded: item?.tokenRefunded
    }));
}
// Convert time labels to API query parameters
export const timeToParam = (timeLabel) => {
    switch (timeLabel) {
        case "1 Day": return "1";
        case "3 Days": return "3";
        case "7 Days": return "seven";
        case "1 Month": return "month";
        case "1 Year": return "year";
        default: return "1";
    }
};
// Format dates for display in the filter tag
export const formatDisplayDates = (start, end) => {
    if (!start || !end) return "";
    return `${moment(start).format('MMM D, YYYY')} - ${moment(end).format('MMM D, YYYY')}`;
};